(function () {
/*
 * -----------------------------------------------------------------------------
 * @cam/product-form-variants
 * -----------------------------------------------------------------------------
 * @version 0.0.1
 * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
 * Derived from @Shopify/dawn - https://github.com/Shopify/dawn
 * Copyright (c) 2021-present Shopify Inc.
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, sell and/or create derivative works of the Software or any part thereof, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * The rights granted above may only be exercised to develop themes that integrate or interoperate with Shopify software or services, and, if applicable, to distribute, offer for sale or otherwise make available any such themes via the Shopify Theme Store. All other uses of the Software are strictly prohibited.
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * -----------------------------------------------------------------------------
 * @requires @cam/product-form
 * -----------------------------------------------------------------------------
*/ if (customElements.get("product-form-variants") === undefined) {
    class ProductFormVariants extends HTMLElement {
        constructor(){
            super();
            this.ProductForm = document.querySelector(`#${this.dataset.productForm}`)?.closest("product-form");
            if (!this.ProductForm || this.getVariantData().length === 1) return;
            this.addEventListener("change", this.changeEvent.bind(this));
        }
        getVariantData() {
            return this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        }
        changeEvent(event) {
            this.setOptions();
            this.setVariantId();
            if (!this.currentVariant) return;
            this.updateVariantInput();
            this.updateURL();
            this.setButtonState();
            this.ProductForm.updateErrorMessage();
        }
        setOptions() {
            this.optionSelection = this.querySelector("[data-options-type]");
            if (!this.optionSelection) return;
            if (this.optionSelection.dataset.optionsType == "dropdowns") this.options = Array.from(this.querySelectorAll("select"), (select)=>select.value);
            else this.options = Array.from(this.querySelectorAll("fieldset")).map((fieldset)=>{
                return Array.from(fieldset.querySelectorAll("input")).find((radio)=>radio.checked).value;
            });
        }
        setVariantId() {
            this.currentVariant = this.getVariantData().find((variant)=>{
                return !variant.options.map((option, index)=>{
                    return this.options[index] === option;
                }).includes(false);
            });
        }
        updateVariantInput() {
            this.ProductForm.idInput.value = this.currentVariant.id;
            this.ProductForm.idInput.dispatchEvent(new Event("change"));
        }
        updateURL() {
            if (!window.location.pathname.includes(this.ProductForm.dataset.productUrl)) return;
            window.history.replaceState({}, "", `${this.ProductForm.dataset.productUrl}?variant=${this.currentVariant.id}`);
        }
        setButtonState() {
            if (!this.currentVariant) {
                this.ProductForm.submitButton.setAttribute("disabled", true);
                this.ProductForm.submitButton.textContent = window.language.unavailable;
            } else if (!this.currentVariant.available) {
                this.ProductForm.submitButton.setAttribute("disabled", true);
                this.ProductForm.submitButton.textContent = window.language.soldOut;
            } else {
                this.ProductForm.submitButton.removeAttribute("disabled");
                this.ProductForm.submitButton.textContent = window.language.addToCart;
            }
        }
    }
    customElements.define("product-form-variants", ProductFormVariants);
}



})();
